const releaseNoteDialog = {
  "release-notes.dialog.version": "Version {{ version }}",
};

const releaseNotesCommon = {
  "release-notes.whats-new": "What's New",
  "release-notes.whats-new-count": "What's New ({{ count }})",
  "release-notes.loading": "Loading...",
  "release-notes.draft": "Draft",
  "release-notes.delete-confirm": "Are you sure you want to delete version {{ version }}?",
};

const releaseNotesAdmin = {
  "release-notes.admin.page.create-button": "Create New Release Note",
  "release-notes.admin.page.previous-notes": "Previous Release Notes",

  // Editor Dialog
  "release-notes.editor-dialog.title.create": "Create New Release Note",
  "release-notes.editor-dialog.title.edit": "Edit Release Note",
  "release-notes.editor-dialog.editing-draft": "Editing draft note",
  "release-notes.editor-dialog.editing-published": "Editing published note",
  "release-notes.editor-dialog.version-placeholder": "Version (e.g., 1.2.3)",
  "release-notes.editor-dialog.preview": "Preview",
  "release-notes.editor-dialog.show-preview": "Show Preview",
  "release-notes.editor-dialog.hide-preview": "Hide Preview",
  "release-notes.editor-dialog.button.cancel": "Cancel",
  "release-notes.editor-dialog.button.save-draft": "Save Draft",
  "release-notes.editor-dialog.button.update-draft": "Update Draft",
  "release-notes.editor-dialog.button.publish": "Publish",
  "release-notes.editor-dialog.button.update-published": "Update Published Note",
  "release-notes.editor-dialog.button.saving": "Saving...",
  "release-notes.editor-dialog.button.publishing": "Publishing...",
  
  // Media Upload
  "release-notes.admin.upload-media.title": "Upload Images",
  "release-notes.admin.upload-media.pending": "Pending Uploads:",
  
  // Menu Bar
  "release-notes.admin.menu-bar.bold": "bold",
  "release-notes.admin.menu-bar.italic": "italic",
  "release-notes.admin.menu-bar.h1": "h1",
  "release-notes.admin.menu-bar.h2": "h2",
  "release-notes.admin.menu-bar.h3": "h3",
  "release-notes.admin.menu-bar.bullet-list": "bullet list",
  "release-notes.admin.menu-bar.ordered-list": "ordered list",
  "release-notes.admin.menu-bar.code-block": "code block",
  
  // Actions
  "release-notes.admin.actions.view": "View Content",
  "release-notes.admin.actions.hide": "Hide Content",
  "release-notes.admin.actions.edit": "Edit",
  "release-notes.admin.actions.publish": "Publish",
  "release-notes.admin.actions.unpublish": "Unpublish",
  "release-notes.admin.actions.delete": "Delete",
  
  // Error messages
  "release-notes.admin.error.upload-media": "Failed to upload media",
  "release-notes.admin.error.save": "Failed to save version",
  "release-notes.admin.error.publish": "Failed to publish release note",
  "release-notes.admin.error.unpublish": "Failed to unpublish release note",
  "release-notes.admin.error.delete": "Failed to delete release note",
  "release-notes.admin.error.try-again": "Please try again or contact support.",
};

export const releaseNotes = { ...releaseNoteDialog, ...releaseNotesCommon, ...releaseNotesAdmin };
